<template>
	<div class="grid-flex-container" v-if="hasData">
		<div class="generic-grid-container pa-4" style="overflow-y: scroll">
			<v-form ref="form">
				<v-select
					v-model="dateFormat.Value"
					:items="dateFormats"
					:rules="[rules.required]"
					item-value="Id"
					item-text="title"
					label="Date Format"
				/>
				<v-select
					v-model="dateTimeFormat.Value"
					:items="dateTimeFormats"
					:rules="[rules.required]"
					item-value="Id"
					item-text="title"
					label="Date Time Format"
				/>
				<v-select
					v-model="gridAssetsWidth.Value"
					:rules="[rules.required]"
					:items="widthValues"
					item-value="Id"
					item-text="title"
					name="gridAssetsWidth"
					label="Assets grid width"
				/>
				<v-select
					v-model="gridCatalogsWidth.Value"
					:rules="[rules.required]"
					:items="widthValues"
					item-value="Id"
					item-text="title"
					name="gridAssetsWidth"
					label="Catalogs grid width"
				/>
				<v-select
					v-model="gridDepartmentsWidth.Value"
					:rules="[rules.required]"
					:items="widthValues"
					item-value="Id"
					item-text="title"
					name="gridAssetsWidth"
					label="Departments grid width"
				/>
				<v-select
					v-model="gridNamesWidth.Value"
					:rules="[rules.required]"
					:items="widthValues"
					item-value="Id"
					item-text="title"
					name="gridAssetsWidth"
					label="End-User Names grid width"
				/>
				<v-select
					v-model="gridLocationsWidth.Value"
					:rules="[rules.required]"
					:items="widthValues"
					item-value="Id"
					item-text="title"
					name="gridAssetsWidth"
					label="Locations grid width"
				/>

				<v-select
					v-model="gridCustomTablesWidth.Value"
					:rules="[rules.required]"
					:items="widthValues"
					item-value="Id"
					item-text="title"
					name="gridAssetsWidth"
					label="Custom Tables width"
				/>
				<v-select
					v-model="userDisplayFormat.Value"
					:rules="[rules.required]"
					:items="userDisplayFormatValues"
					item-value="Id"
					item-text="title"
					name="userDisplayFormat"
					label="User display format"
				/>
				<v-text-field
					v-model="primaryKeyExeptionValue"
					label="Primary key exceptions"
					hint=" "
					persistent-hint
				>
					<template v-slot:prepend-inner>
						<v-btn
							class="mt-0 mb-1"
							small
							color="primary"
							@click="addToExeptionList()"
						>
							Add</v-btn
						>
					</template>
					<template v-slot:message>
						<div v-if="loadingExeptionList">
							<v-progress-linear
								indeterminate
							></v-progress-linear>
						</div>
						<div v-if="!loadingExeptionList">
							<v-chip
								class="mr-1 mb-1"
								v-for="(
									item, index
								) in primaryKeyExeptionList.Value"
								:key="index"
								close
								@click:close="removeToExeptionList(index)"
							>
								{{ item }}
							</v-chip>
						</div>
					</template>
				</v-text-field>
			</v-form>
		</div>
		<v-container fluid class="align-end">
			<v-row no-gutters>
				<v-spacer />
				<v-btn color="primary" @click="onSubmit()">Submit</v-btn>
			</v-row>
		</v-container>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { GeneralSettingsActions } from '../../../store/actions';
import { GeneralSettingsGetters } from '../../../store/getters';
import { GeneralSettings } from '../../../enums/GeneralSettings';
export default {
	name: 'GeneralSettings',
	data() {
		return {
			hasData: false,
			dateTimeFormat: null,
			dateFormat: null,
			dateOnlyFormat: null,
			gridAssetsWidth: null,
			gridCatalogsWidth: null,
			gridDepartmentsWidth: null,
			gridLocationsWidth: null,
			gridNamesWidth: null,
			gridCustomTablesWidth: null,
			userDisplayFormat: null,

			primaryKeyExeptionValue: null,
			primaryKeyExeptionList: null,
			loadingExeptionList: false,

			widthValues: [
				{ Id: '1', title: '100%' },
				{ Id: '2', title: '50%' },
			],
			userDisplayFormatValues: [
				{ Id: '1', title: 'First Name  Last Name' },
				{ Id: '2', title: 'Last Name  First Name' },
				{ Id: '3', title: 'Email' },
				{ Id: '4', title: 'Username' },
				{ Id: '5', title: 'First Name  Last Name - Email' },
				{ Id: '6', title: 'Last Name  First Name - Email' },
				{ Id: '7', title: 'First Name  Last Name - Username' },
				{ Id: '8', title: 'Last Name  First Name - Username ' },
			],

			dateTimeFormats: [
				{ Id: 'MM-DD-YYYY HH:mm', title: 'mm-dd-yyyy hh:mm' },
				{ Id: 'MM-DD-YYYY HH:mm:ss', title: 'mm-dd-yyyy hh:mm:ss' },

				{ Id: 'MM/DD/YYYY HH:mm', title: 'mm/dd/yyyy hh:mm' },
				{ Id: 'MM/DD/YYYY HH:mm:ss', title: 'mm/dd/yyyy hh:mm:ss' },

				{ Id: 'DD-MM-YYYY HH:mm', title: 'dd-mm-yyyy hh:mm' },
				{ Id: 'DD-MM-YYYY HH:mm:ss', title: 'dd-mm-yyyy hh:mm:ss' },
				{ Id: 'DD/MM/YYYY HH:mm', title: 'dd/mm/yyyy hh:mm' },
				{ Id: 'DD/MM/YY HH:mm:ss', title: 'dd/mm/yy hh:mm:ss' },

				{ Id: 'YYYY-MM-DD HH:mm', title: 'yyyy-mm-dd hh:mm' },
				{ Id: 'YYYY-MM-DD HH:mm:ss', title: 'yyyy-mm-dd hh:mm:ss' },
				{ Id: 'YYYY/MM/DD HH:mm', title: 'yyyy/mm/dd hh:mm' },
				{ Id: 'YYYY/MM/DD HH:mm:ss', title: 'yyyy/mm/dd hh:mm:ss' },
			],
			dateFormats: [
				{ Id: 'MM-DD-YYYY', title: 'mm-dd-yyyy' },
				{ Id: 'MM/DD/YYYY', title: 'mm/dd/yyyy' },
				{ Id: 'DD-MM-YYYY', title: 'dd-mm-yyyy' },
				{ Id: 'DD/MM/YYYY', title: 'dd/mm/yyyy' },
				{ Id: 'YYYY-MM-DD', title: 'yyyy-mm-dd' },
				{ Id: 'YYYY/MM/DD', title: 'yyyy/mm/dd' },
			],
			rules: {
				required: (value) => !!value || 'Field is required',
			},
		};
	},
	computed: {
		...mapGetters({
			settings: [GeneralSettingsGetters.SETTINGS],
		}),
	},
	mounted() {
		this.$store
			.dispatch(GeneralSettingsActions.LOAD_SETTINGS)
			.then((success) => {
				this.hasData = success;
				if (!success) return;

				this.dateTimeFormat = this.settings.find(
					(x) => x.Name == GeneralSettings.DATE_TIME_FORMAT
				);
				this.dateFormat = this.settings.find(
					(x) => x.Name == GeneralSettings.DATE_FORMAT
				);
				this.gridAssetsWidth = this.settings.find(
					(x) => x.Name == GeneralSettings.GRID_ASSET_WIDTH
				);
				this.gridCatalogsWidth = this.settings.find(
					(x) => x.Name == GeneralSettings.GRID_CATALOG_WIDTH
				);
				this.gridDepartmentsWidth = this.settings.find(
					(x) => x.Name == GeneralSettings.GRID_DEPARTMENT_WIDTH
				);
				this.gridLocationsWidth = this.settings.find(
					(x) => x.Name == GeneralSettings.GRID_LOCATION_WIDTH
				);
				this.gridNamesWidth = this.settings.find(
					(x) => x.Name == GeneralSettings.GRID_NAMES_WIDTH
				);
				this.gridCustomTablesWidth = this.settings.find(
					(x) => x.Name == GeneralSettings.GRID_CUSTOM_TABLE_WIDTH
				);
				this.userDisplayFormat = this.settings.find(
					(x) => x.Name == GeneralSettings.USER_DISPLAY_FORMAT
				);
				this.primaryKeyExeptionList = this.settings.find(
					(x) => x.Name == GeneralSettings.PRIMARY_KEY_EXEPTION_LIST
				);
			});
	},
	methods: {
		addToExeptionList() {
			if (this.primaryKeyExeptionValue) {
				if (!this.primaryKeyExeptionList.Value)
					this.primaryKeyExeptionList.Value = [];
				this.primaryKeyExeptionList.Value.push(
					this.primaryKeyExeptionValue
				);
			}
			this.primaryKeyExeptionValue = null;
		},
		removeToExeptionList(index) {
			if (this.primaryKeyExeptionList.Value[index])
				this.primaryKeyExeptionList.Value.splice(index, 1);
		},
		onSubmit() {
			if (!this.$refs.form.validate()) return;
			let items = [
				this.dateFormat,
				this.dateTimeFormat,
				this.gridAssetsWidth,
				this.gridCatalogsWidth,
				this.gridDepartmentsWidth,
				this.gridLocationsWidth,
				this.gridNamesWidth,
				this.gridCustomTablesWidth,
				this.userDisplayFormat,
				this.primaryKeyExeptionList,
			];
			this.loadingExeptionList = true;
			this.$store
				.dispatch(GeneralSettingsActions.SAVE_SETTINGS, items)
				.finally(() => {
					this.loadingExeptionList = false;
				});
		},
	},
};
</script>
